import React, { useEffect, useRef } from 'react';
import './Skills.css';
import SkillCard from './SkillCard';
import { experience } from '../../data';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

const Skills = () => {
  const sectionRef = useRef(null);

  // Register GSAP plugin
  gsap.registerPlugin(ScrollTrigger);

  useEffect(() => {
    gsap.fromTo(
      sectionRef.current.querySelectorAll('.skill__card'),
      { opacity: 0, y: 50 },
      {
        opacity: 1,
        y: 0,
        duration: 1,
        stagger: 0.2, // Animate cards with a slight delay between each
        scrollTrigger: {
          trigger: sectionRef.current,
          start: 'top 80%',
          toggleActions: 'play none none reverse',
        },
      }
    );
  }, []);

  return (
    <section id="skills" ref={sectionRef}>
      <div className="section__wrapper">
        <div className="section__header center">
          <h2 className="primary__title">My Skills</h2>
          <h1 className="title">My <span className="color__primary">Expertise</span></h1>
        </div>
        <div className="skill__container">
          {experience.map((list, index) => (
            <SkillCard key={index} title={list.title} data={list.data} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
